import { appUrl, appointmentChannelId, form, locations, originProcedures, procedureIdSelected, procedures, proceduresOfAppointmentChannel, providerId, selectedStaffAppointmentChannel, sourceParam, staffId } from "../../utils/variables";
import { params } from "../events/movePages";
import { HOST_TYPE_ONE_ON_ONE, HOST_TYPE_ROUND_ROBIN, HOST_TYPE_COLLECTIVE } from "../../utils/constants";
import parsePhoneNumberFromString from "libphonenumber-js";
import { formatPhoneNumber } from "./countryCodeActions";

function canUserChooseStaff(hostType, staffCount) {
    switch (hostType) {
        case HOST_TYPE_ONE_ON_ONE:
            return staffCount > 1;
        case HOST_TYPE_ROUND_ROBIN:
        case HOST_TYPE_COLLECTIVE:
            return false;
        default:
            return form?.appointment_channel?.visitor_can_choose_the_staff;
    }
}

function getHostType() {
    return form?.appointment_channel?.host || HOST_TYPE_ONE_ON_ONE;
}

export function renderStaffInfoHeader(staff, procedure, container, isAppend = false) {
    const staffsOfAppointmentChannel = form?.appointment_channel?.staffs?.filter(staff => staff?.online_booking)
    const foundStaff = staff ?? form?.staff?.find(staff => staff.id === +staffId);
    const foundProcedure = procedure ?? procedures.find(p => p?.id === +procedureIdSelected)
    const infoStaffContainer = document.querySelector(`${container ? '.' + container : ''} .infoStaff`);
    const isMultipleStaff = staffsOfAppointmentChannel?.length > 1;
    const { duration, location } = form.appointment_channel
    const currentLocation = location ? location : locations?.length === 1 ? locations[0] : null
    const descriptionAppointmentChannel = form?.appointment_channel?.description ?? ''
    const appointment_channel_name = form?.appointment_channel?.appointment_channel_name ?? ''

    const hostType = getHostType();
    const staffCount = staffsOfAppointmentChannel?.length || 0;
    const canChooseStaff = canUserChooseStaff(hostType, staffCount);

    let providerSelected = null
    if (appointmentChannelId && canChooseStaff) {
        providerSelected = staffsOfAppointmentChannel?.find(staff => staff?.id == selectedStaffAppointmentChannel)
    }

    const renderListStaff = () => {
        const MAX_STAFF_DISPLAY = 4
        const staffs = appointmentChannelId ? (canChooseStaff && providerSelected) ? [providerSelected] : staffsOfAppointmentChannel : [foundStaff]
        
        if (!staffs?.length) {
            return ``
        }

        const shouldShowList = staffs.length > 1 || (canChooseStaff && providerSelected)
        if (!shouldShowList) {
            return ``
        }

        const displayStaffs = staffs.slice(0, MAX_STAFF_DISPLAY)
        const remainingCount = staffs.length - MAX_STAFF_DISPLAY

        let iconStaffs = ``
        for (const i of displayStaffs) {
            iconStaffs = iconStaffs.concat(`
                <div class="staff-item">
                    <div class="img">
                    <img src="${i?.photo ? encodeURI(i.photo) : `${appUrl}/assets/images/png/default-avatar.png`}" alt="">
                    </div>
                    <span class="name">${i?.first_name ?? ""} ${i?.last_name ?? ""}</span>
                </div>
            `)
        }

        if (remainingCount > 0) {
            iconStaffs = iconStaffs.concat(`
                <div class="staff-item staff-item-more">
                    <div class="img">
                        <span class="staff-more-count">+${remainingCount}</span>
                    </div>
                </div>
            `)
        }

        return iconStaffs
    }

    const getDuration = (durationProcedure) => {
        const durationTime = moment.duration(durationProcedure, 'm');
        let textDuration = '';
        if (durationTime._data.hours >= 0 && durationTime._data.minutes > 0) {
            textDuration = `${moment.duration(durationProcedure, 'm').format('h[h] m')}min`;
        } else {
            textDuration = moment.duration(durationProcedure, 'm').format('h[h]');
        }

        return textDuration
    };

    const renderStaffInfo = () => {
        const getStaff = appointmentChannelId ? staffsOfAppointmentChannel[0] : foundStaff
        if (!staff && !staffsOfAppointmentChannel?.length) {
            return "<div>No staffs</div>"
        }
        return (`
         ${!isMultipleStaff ?
                `<div class="img">
                    <img src="${getStaff?.photo ? encodeURI(getStaff?.photo) : `${appUrl}/assets/images/png/default-avatar.png`}" alt="avatar">
                </div>`
                : ''}
                ${isMultipleStaff ?
                `       
                <div class="infoStaff__header ${isMultipleStaff ? "flex-column" : ""}">
                    <h3>Meet with</h3>
                    <div class="list-staff">
                    ${renderListStaff()}
                    </div>
                </div>    
                    `
                : `<h3>${appointment_channel_name}</h3>`
            }
        `)
    }

    const renderProcedureInfo = () => {
        const getProcedures = appointmentChannelId ? proceduresOfAppointmentChannel : [foundProcedure]
        const namesProcedure = getProcedures?.map(i => i.name).join(', ')
        const durationProcedure = getProcedures?.reduce((n, { duration }) => n + duration, 0);
        if (!namesProcedure) {
            return "<div>No services</div>"
        }

        return `
            ${((getProcedures?.length === 1) || duration) ?
                `<div class="staffInfo__description">
                        <span><i data-feather="clock"></i></span>
                        <div class="staffInfo__description-left">
                            <span class="staffInfo__description-title">Duration</span>
                            <span class="staffInfo__description-name">${getDuration(duration > 0 ? duration : durationProcedure)}</span>
                        </div>
                    </div>`
                : ''
            }
           ${getProcedures?.length === 1 ?
                `
                 <div class="divider">
                    <hr />
                </div>
                 <div class="staffInfo__description">
                    <span><i data-feather="activity"></i></span>
                    <div class="staffInfo__description-left">
                        <span class="staffInfo__description-title">Appointment Type</span>
                        <span class="staffInfo__description-name">${namesProcedure}</span>
                    </div>
                </div>
            ` : ``
            }
        `
    }

    const renderDescriptionInfo = () => {
        if (!descriptionAppointmentChannel) {
            return ""
        }
        return `
            <div class="staffInfo__description">
                <span><i data-feather="file-text"></i></span>
                <div class="staffInfo__description-left">
                    <span class="staffInfo__description-title">Description</span>
                    <span class="staffInfo__description-name">${descriptionAppointmentChannel || ""}</span>
                </div>
            </div>
        `
    }

    const renderLocationInfo = () => {
        const hasVirtualVisit = form?.appointment_channel?.is_virtual_meeting;
        if (hasVirtualVisit) {
            const phoneNumber = currentLocation?.phone || '';
            let formattedPhone = phoneNumber;

            if (phoneNumber) {
                try {
                    const parsedPhone = parsePhoneNumberFromString(phoneNumber, currentLocation?.country || 'US');
                    if (parsedPhone && parsedPhone.isValid()) {
                        formattedPhone = parsedPhone.formatNational();
                    } else {
                        formattedPhone = formatPhoneNumber(phoneNumber, currentLocation?.country || 'US');
                    }
                } catch (error) {
                    formattedPhone = phoneNumber;
                }
            }
            return `Virtual ${formattedPhone || ""}`
        }
        return currentLocation?.name || currentLocation?.full_address || ""
    }


    if (infoStaffContainer) {
        const infoStaffHeaderHTML = `
            <div class="staffInfo__wrapper">
                ${renderStaffInfo()}    
                ${renderProcedureInfo()}
                ${currentLocation ? `
                <div class="divider">
                    <hr />
                </div>
                <div class="staffInfo__description">
                    <span><i data-feather="map-pin"></i></span>
                    <div class="staffInfo__description-left">
                        <span class="staffInfo__description-title">Location</span>
                        <span class="staffInfo__description-name">${renderLocationInfo()}</span>
                    </div>
                </div>
                ${renderDescriptionInfo()}
                ` : ""
            }
            </div>
        `
        if (isAppend) {
            infoStaffContainer.innerHTML = ''
            infoStaffContainer.insertAdjacentHTML('afterbegin', `${infoStaffHeaderHTML}`);
        } else {
            infoStaffContainer.innerHTML = infoStaffHeaderHTML
        }
    }
    feather.replace();
}